import { render, staticRenderFns } from "./ZBadge.vue?vue&type=template&id=55f5bc1c&scoped=true&"
import script from "./ZBadge.vue?vue&type=script&lang=js&"
export * from "./ZBadge.vue?vue&type=script&lang=js&"
import style0 from "./ZBadge.vue?vue&type=style&index=0&id=55f5bc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5bc1c",
  null
  
)

export default component.exports